module.exports = __webpack_public_path__ + "images/emoji/date.376ec85e289d93725c86.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/date.png
// module id = ih/b
// module chunks = 1